{
  "R": [0, 103, 255],
  "G": [0, 126, 255],
  "B": [0, 165, 255],
  "A": [0, 76, 128],
  "I": [0, 153, 255]
}
